var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPackage = function SvgPackage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "package_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#package_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 3c-.367 0-.68.13-.942.392a1.284 1.284 0 0 0-.391.941v7.334c0 .366.13.68.391.941.261.261.575.392.942.392h12c.367 0 .68-.13.942-.392.26-.26.391-.575.391-.941v-6c0-.367-.13-.68-.391-.942A1.284 1.284 0 0 0 14 4.333H8.667L7.333 3H2Zm0 1h5.333l1.334 1.333H14V6H2V4Zm0 2.667v5h12v-5H2Z",
    fill: "#404040"
  }))));
};
export default SvgPackage;